export function resolvePlurality(votes) {
    const counts = new Map();
    for (const target of votes) {
        if (target)
            counts.set(target, (counts.get(target) ?? 0) + 1);
    }
    if (counts.size === 0)
        return { target: null, tied: false, maxVotes: 0 };
    const maxVotes = Math.max(...counts.values());
    const leaders = [...counts.entries()]
        .filter(([, count]) => count === maxVotes)
        .map(([target]) => target);
    return {
        target: leaders.length === 1 ? leaders[0] : null,
        tied: leaders.length > 1,
        maxVotes,
    };
}
export function resolveNight(input) {
    const deaths = new Set();
    const wolfKillPrevented = Boolean(input.wolfTarget
        && (input.wolfTarget === input.guardTarget || input.witchHealed));
    if (input.wolfTarget && !wolfKillPrevented)
        deaths.add(input.wolfTarget);
    if (input.poisonTarget)
        deaths.add(input.poisonTarget);
    return { deaths: [...deaths], wolfKillPrevented };
}
export function determineWinner(livingPlayers) {
    const living = livingPlayers.filter((player) => player.alive);
    const wolves = living.filter((player) => player.role === "WEREWOLF").length;
    const villagers = living.length - wolves;
    if (wolves === 0)
        return "VILLAGERS";
    if (wolves >= villagers)
        return "WEREWOLVES";
    return null;
}
export function durationForPhase(phase, settings) {
    switch (phase) {
        case "ROLE_REVEAL":
            return 20;
        case "NIGHT_GUARD":
        case "NIGHT_WOLVES":
        case "NIGHT_SEER":
        case "NIGHT_WITCH":
        case "HUNTER_REACTION":
            return settings.nightActionSeconds;
        case "NIGHT_RESOLUTION":
            return 2;
        case "MORNING":
            return 8;
        case "DISCUSSION":
            return settings.discussionSeconds;
        case "VOTING":
            return settings.votingSeconds;
        case "VOTE_RESULT":
            return 5;
        default:
            return 0;
    }
}
export const ROLE_LABELS = {
    WEREWOLF: "Ma sói",
    VILLAGER: "Dân làng",
    SEER: "Tiên tri",
    WITCH: "Phù thủy",
    HUNTER: "Thợ săn",
    GUARD: "Bảo vệ",
};
export const ROLE_DESCRIPTIONS = {
    WEREWOLF: "Cùng bầy sói chọn một nạn nhân mỗi đêm. Đừng để dân làng nhận ra bạn.",
    VILLAGER: "Bạn không có năng lực ban đêm. Hãy quan sát, tranh luận và tìm ra Ma sói.",
    SEER: "Mỗi đêm, soi một người để biết họ có phải Ma sói hay không.",
    WITCH: "Bạn có một bình cứu và một bình độc. Mỗi bình chỉ được dùng một lần.",
    HUNTER: "Nếu chết, bạn có quyền bắn hạ một người trước khi rời làng.",
    GUARD: "Mỗi đêm bảo vệ một người khỏi nanh vuốt của Ma sói.",
};
export const PHASE_COPY = {
    LOBBY: { title: "Sảnh chờ", narration: "Dân làng đang tụ họp dưới ánh trăng đỏ." },
    ROLE_REVEAL: { title: "Lá bài định mệnh", narration: "Số phận của bạn đã được mở ra…" },
    NIGHT_GUARD: { title: "Bảo vệ thức giấc", narration: "Một bóng người lặng lẽ bước qua màn sương." },
    NIGHT_WOLVES: { title: "Ma sói thức giấc", narration: "Một tiếng hú vang lên từ khu rừng phía xa." },
    NIGHT_SEER: { title: "Tiên tri thức giấc", narration: "Đôi mắt cổ xưa nhìn xuyên qua mọi lời dối trá." },
    NIGHT_WITCH: { title: "Phù thủy thức giấc", narration: "Hai chiếc bình khẽ va vào nhau trong bóng tối." },
    NIGHT_RESOLUTION: { title: "Đêm định đoạt", narration: "Số phận đang được viết bằng máu và tro." },
    HUNTER_REACTION: { title: "Phát súng cuối cùng", narration: "Thợ săn siết chặt cò súng lần cuối." },
    MORNING: { title: "Bình minh", narration: "Dân làng tỉnh giấc trong nỗi sợ hãi." },
    DISCUSSION: { title: "Hội đồng làng", narration: "Ai là kẻ đang nói dối?" },
    VOTING: { title: "Phán quyết", narration: "Lá phiếu cuối cùng sắp được đặt xuống…" },
    VOTE_RESULT: { title: "Kết quả phán quyết", narration: "Ngôi làng nín thở trước lựa chọn của mình." },
    ENDED: { title: "Đêm trăng khép lại", narration: "Mọi bí mật cuối cùng đều bị phơi bày." },
};
//# sourceMappingURL=engine.js.map